import React, { memo } from 'react';

import PropTypes from 'prop-types';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';

import '../../styles/revamp/before-after-image.scss';

function BeforeAfterImage(props) {
  const { imageData } = props;
  return (
    <div className="before-after-image-wrapper">
      <ReactCompareSlider
        itemOne={<ReactCompareSliderImage
          src={`/img/updated/homepage/before_after/${imageData.name}_Before.jpg`}
          data-gumlet="false"
          alt="Image one"
        />}
        itemTwo={<ReactCompareSliderImage
          src={`/img/updated/homepage/before_after/${imageData.name}_After.jpg`}
          data-gumlet="false"
          alt="Image two"
        />}
        position={50}
      />
    </div>
  );
}
export default memo(BeforeAfterImage);
BeforeAfterImage.propTypes = {
  imageData: PropTypes.shape()
};

BeforeAfterImage.defaultProps = {
  imageData: {}
};
